import React from 'react';
import styled from 'styled-components/native';
import StudyParticipantCard from '../study/cards/StudyParticipantCard';
import { addDays } from 'date-fns';
import Chip from '../../components/Chip';
import { log } from '../../tools/LogHelper';

const StyledView = styled.View`
  flex: 1;
  align-items: center;
  justify-content: center;
  background-color: white;
`;

const ExampleStudyCardScreen: React.FC = () => {
  const accessory = (
    <Chip size='small' color='#ccf5ff'>
      Clinical
    </Chip>
  );

  const mockData = {
    name: 'CBD Sleep Study',
    imageUrl:
      'https://drive.google.com/uc?id=1yu2LAbdPkH34iqvsOP4XMlwERmGqn4Wj',
    backgroundColor: '#000',
    startDate: addDays(new Date(), -12),
    studyLength: 25
  };

  return (
    <StyledView>
      <StudyParticipantCard
        name={mockData.name}
        imageUrl={mockData.imageUrl}
        backgroundColor={mockData.backgroundColor}
        startDate={mockData.startDate}
        studyLength={mockData.studyLength}
        accessory={accessory}
        onFavorite={() => {
          log('Favorite Pressed');
        }}
        onShare={() => {
          log('Share Pressed');
        }}
      />
    </StyledView>
  );
};

export default ExampleStudyCardScreen;
